import { StatusCode } from '../sale'
import { saleSelectors } from 'src/app/features/sale/sale.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { combineLatest, Observable, of } from 'rxjs'
import { catchError, filter, map, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { Sale } from '../sale'
import { saleActions } from '../sale.actions'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

@UntilDestroy()
@Component({
  selector: 'sale-general-card',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SaleGeneralCardComponent implements OnInit {
  @Input() readonly: boolean = false
  public sale$: Observable<Sale>
  public saleId$: Observable<number>
  public creditSales$: Observable<Sale[]>
  public form: UntypedFormGroup
  public saleStatusCode = StatusCode

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}
  ngOnInit() {
    this.saleId$ = this.store
      .select(saleSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.sale$ = combineLatest([
      this.saleId$,
      this.store.select(saleSelectors.selectEntities)
    ]).pipe(
      untilDestroyed(this),
      map(([saleId, saleEntities]) => saleEntities[saleId]),
      filter((sale) => Boolean(sale))
    )

    this.sale$.pipe(take(1)).subscribe((sale) => {
      this.store.dispatch(
        saleActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              isCreditOfSaleId: sale.id
            },
            join: [
              { field: 'creditSales' },
              { field: 'organization' },
              { field: 'customer' },
              { field: 'payments' }
            ]
          })
        })
      )

      if (sale.isCreditOfSaleId) {
        this.store.dispatch(
          saleActions.fetchOneById({
            id: sale.isCreditOfSaleId,
            params: RequestQueryBuilder.create({
              join: [
                { field: 'creditSales' },
                { field: 'organization' },
                { field: 'customer' },
                { field: 'payments' }
              ]
            })
          })
        )
      }
    })

    this.creditSales$ = combineLatest([
      this.store.select(saleSelectors.selectAll),
      this.sale$
    ]).pipe(
      map(([allSales, sale]) => {
        if (sale.total >= 0) {
          return allSales?.filter((s) => s.isCreditOfSaleId == sale.id)
        } else if (sale.isCreditOfSaleId) {
          return allSales?.filter((s) => s.id == sale.isCreditOfSaleId)
        }
        return []
      })
    )
  }

  public onSubmit(form): void {
    const internalNote: any = form.internalNote ? form.internalNote : null
    // we only update the organization id for this form
    this.saleId$.pipe(take(1)).subscribe((saleId) =>
      this.store.dispatch(
        saleActions.updateOneById({
          id: saleId,
          params: {
            // ...form,
            internalNote: internalNote,
            customerPersonId: form.customerPersonId,
            orderNumber: form.orderNumber,
            organizationId: form.organizationId,
            id: parseInt(saleId.toString())
          }
        })
      )
    )

    this.actions$
      .pipe(
        ofType(saleActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
